import React from 'react';

import './Footer.css';

const Footer = () => (
  <footer>
    <p>Powered by Piwik PRO</p>
  </footer>
);

export { Footer };
